var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRogue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.92 6.61L8 8.5c1.19-.5-.1 1.07 4 1 3.85 0 3.5-1.32 4-1l-2.92-1.89a2 2 0 00-2.16 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78 13.46l-.54-3.5A5.68 5.68 0 017.7 5.2L9.5 3.4a3.05 3.05 0 014.9.8c.35.7 1.03 1.33 1.77 1.55a2.79 2.79 0 011.99 3.08l-.66 4.63 3.5 1c-.5 2.52-2.5 7.04-8.5 7.04s-9-4.02-9.5-6.54c1.5-1 2.73-1.17 3.78-1.5zm4.11.68L9.2 12.9a2.01 2.01 0 01-.8-1.36L8 8.5l2.92-1.89a2 2 0 012.16 0L16 8.5v2.78c0 .68-.35 1.32-.92 1.7l-1.92 1.24a2 2 0 01-2.27-.08z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stroke-only",
    d: "M8 8.5l.39 3.03c.07.54.36 1.03.8 1.36l1.7 1.25a2 2 0 002.27.08l1.92-1.25c.57-.37.92-1 .92-1.69V8.5m-8 0l2.92-1.89a2 2 0 012.16 0L16 8.5m-8 0c1.19-.5-.1 1.07 4 1 3.85 0 3.5-1.32 4-1m-9.22 4.96C7.2 14.63 8 19 14.45 19m-7.67-5.54l-.54-3.5A5.68 5.68 0 017.7 5.2L9.5 3.4a3.05 3.05 0 014.9.8c.35.7 1.03 1.33 1.77 1.55a2.79 2.79 0 011.99 3.08l-.66 4.63m-10.72 0c-1.05.33-2.28.5-3.78 1.5.5 2.52 3.5 6.54 9.5 6.54s8-4.52 8.5-7.04l-3.5-1m0 0S17 16.5 14 16.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRogue);
export default __webpack_public_path__ + "static/media/rogue.5d5bf9d12a2332f059c2e8f31c909d18.svg";
export { ForwardRef as ReactComponent };